export default __webpack_public_path__ + "static/media/BANANA-XRP-BNB.7414bfd2.svg";